export default {
    data() {
        return {
            bannerHidden: false
        }
    },
    computed: {
        showBetaBanner() {
            let betaBanner = localStorage.getItem("closeBetaBanner");
            return _.get(this, 'corporation.id', null) > 327 && !betaBanner;
        },
    },
    methods: {
        hideBanner() {
            localStorage.setItem('closeBetaBanner', 'true');
            this.bannerHidden = true;
        }
    }
};
